import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="font-heading text-xl font-semibold tracking-tight text-foreground-900">
              gtbuy<span className="font-light">.art</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-xs">
              A product comparison search engine powered by structured spreadsheet data. Compare 5000+ products across Kakobuy, Superbuy, and GTBuy systems instantly.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Pages</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/article-gtbuy-sheet" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  SEO Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors"
                >
                  Main Store
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Social</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-600 hover:bg-foreground-200 hover:text-foreground-900 transition-colors">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-600 hover:bg-foreground-200 hover:text-foreground-900 transition-colors">
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 GTBuy.art &mdash; All rights reserved.
          </p>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <a href="#" className="hover:text-foreground-600 transition-colors">Privacy</a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-foreground-600 transition-colors">Terms</a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-foreground-600 transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}